import React from "react";

const BlogCard = ({ date, description, imgSrc }) => {
  return (
    <>
      <div className="col-lg-4">
        <img src={imgSrc} />
        <p>{date}</p>
        <h4>{description}</h4>
      </div>
    </>
  );
};

export default BlogCard;
